import { useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { GET_AUTH, REFRESH_TOKEN } from 'gql/auth';

const timeout = parseInt(process.env.REACT_APP_TIMEOUT);
const refreshTimer = parseInt(process.env.REACT_APP_REFRESH_TIMER);

const IdelTimer = () => {
  const history = useHistory();
  const { data } = useQuery(GET_AUTH);
  const [refreshToken] = useMutation(REFRESH_TOKEN, {
    variables: { init: false },
    update: (cache, { data: { refreshToken } }) => {
      cache.writeQuery({
        query: GET_AUTH,
        data: {
          auth: {
            token: refreshToken.token,
            me: refreshToken.me,
            isLoggedIn: true,
            loading: false,
          },
        },
      });
    },
    onCompleted: (data) => {
      localStorage.setItem('token', data.refreshToken.token);
    },
  });
  const onIdle = () => {
    history.push('/session-timeout');
  };
  const { getLastActiveTime } = useIdleTimer({
    timeout,
    onIdle,
  });

  useEffect(() => {
    let intervalId = setInterval(() => {
      if (!data?.auth?.isLoggedIn) {
        return;
      }
      const lastActiveTime = moment(getLastActiveTime());
      const now = moment();
      // const diff = now.diff(lastActiveTime, 'seconds');
      const diff = now.diff(lastActiveTime, 'minutes');
      if (diff < 10) {
        // refresh token
        refreshToken();
      }
    }, refreshTimer);
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default IdelTimer;
